export const disabledTextHelperActivities = {
  BuildAKeyboard: true,
  'construct-a-response': true,
  'equation-builder': true,
  'graph-it-image': true,
  'graph-it-table': true,
  MatManMatch: true,
  'multi-part': true,
  MyChoiceKeyboarding: true,
  PuzzlePieces: true,
  'select-it': true,
  WoodPieces: true,
  WriteMyName: true
};
